import { render, staticRenderFns } from "./permitTree233.vue?vue&type=template&id=1b8b55bb"
import script from "./permitTree233.vue?vue&type=script&lang=js"
export * from "./permitTree233.vue?vue&type=script&lang=js"
import style0 from "./permitTree233.vue?vue&type=style&index=0&id=1b8b55bb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports